import React, { Component } from 'react';
import glamorous from 'glamorous';
import { AutoAffix } from 'react-overlays';
import { get, map, isEmpty, isFunction } from 'lodash';
import { compose, onlyUpdateForKeys } from 'recompose';
import { Card, Icon } from '@blueprintjs/core';
import { injectIntl, FormattedMessage } from 'react-intl';
import { VXList, VXPagination } from 'oecd-visions';
import { recallColumns } from '../../utils';

const StyledIcon = glamorous(Icon)({
  cursor: 'pointer',
});

const StyledCard = glamorous(Card)({
  paddingTop: '10px !important',
  paddingBottom: '10px !important',
  marginBottom: '6px',
  cursor: 'default !important',
});

const activeSortCss = {
  border: '1px solid rgba(148,190,8,.5)',
  color: '#94be08',
};

const ListHeader = compose(injectIntl)(
  (props) => {
    const { sort, order, onSortChange, config } = props;
    return (
      <glamorous.Div
        className="pt-card hidden-sm hidden-xs"
        style={props.style}
        css={{
          zIndex: 10,
          paddingTop: `10px !important`,
          paddingBottom: `10px !important`,
          backgroundColor: '#eee !important',
        }}>
        <div className="row">
          {map(recallColumns(config), rc => {
            const { bsClass, dataKey, sortable } = rc;
            const isSortedByThis = dataKey === sort;
            const sortIcons = sortable ? (
              <glamorous.Span>
                <StyledIcon
                  iconName="chevron-down"
                  css={isSortedByThis && order === 'DESC' ? activeSortCss : {}}
                  onClick={() => onSortChange(dataKey, 'DESC')}
                />
                <StyledIcon
                  iconName="chevron-up"
                  css={isSortedByThis && order === 'ASC' ? activeSortCss : {}}
                  onClick={() => onSortChange(dataKey, 'ASC')}
                />
              </glamorous.Span>
            ) : null;
            return (
              <glamorous.Div key={dataKey} className={bsClass} css={{
                wordWrap: 'break-word',
                fontWeight: 'bold',
              }}>
                <FormattedMessage id={rc.intl.title}/>
                {sortIcons}
              </glamorous.Div>
            );
          })}
        </div>
      </glamorous.Div>
    );
  }
);

const RecallItem = (props) => {
  return (
    <StyledCard interactive>
      <div className="row">
        {map(recallColumns(props.config), rc => {
          const { bsClass, label, cellRenderer, dataKey } = rc;
          const cellData = get(props, dataKey);
          const cellContent = isFunction(cellRenderer) ? cellRenderer(props) : cellData;
          const isCellEmpty = isEmpty(cellData) && isEmpty(cellContent);

          return (
            <div className={bsClass} key={dataKey}>
              {!isCellEmpty &&
              <label className="visible-xs visible-sm">
                <FormattedMessage id={rc.intl.title}/>
              </label>}
              {!isCellEmpty && <div>{cellContent}</div>}
            </div>
          )
        })}
      </div>
    </StyledCard>
  );
};

class RecallsList extends Component {
  render() {
    const {
      data,
      currentPage,
      responseInfo,
      order,
      sort,
      updateRecallsSortOpts,
      isFething,
      resetSelection,
      updateRecallsPage,
      config,
    } = this.props;

    const pageSize = get(responseInfo, 'pageLength');
    const hasResetFilters = get(responseInfo, 'total') === 0 && !isFething;
    const hasPagination = !isEmpty(responseInfo) && !isFething;
    const hasHeader = !hasResetFilters && !isFething;

    return (
      <div className="col-md-9">
        {hasHeader &&
        <AutoAffix container={this}>
          <ListHeader
            sort={sort}
            order={order}
            onSortChange={updateRecallsSortOpts}
            config={config}
          />
        </AutoAffix>}
        <VXList
          items={data}
          isLoading={isFething}
          config={config}
          itemRenderer={RecallItem}
          blankLabel={<FormattedMessage id="no.result.message"/>}
        />
        {hasPagination &&
        <glamorous.Div css={{ display: 'flex', justifyContent: 'center' }}>
          <VXPagination
            currentPage={currentPage}
            pageSize={pageSize}
            totalItemsCount={get(responseInfo, 'total')}
            onPageChange={updateRecallsPage}
          />
        </glamorous.Div>}
        {hasResetFilters &&
        <glamorous.Button
          className="btn btn-primary"
          onClick={() => resetSelection(true)}
          css={{
            display: 'block !important',
            margin: '0 auto',
          }}
        >
          <FormattedMessage id="no.result.button"/>
        </glamorous.Button>}
      </div>
    );
  }
}

export default compose(
  onlyUpdateForKeys(['data', 'isFething'])
)(RecallsList);



// WEBPACK FOOTER //
// ./src/views/recalls-list/results-list.js